<div
  class="app-loader"
  [class.app-loader--sm]="size === 'sm'"
  [class.app-loader--lg]="size === 'lg'"
  [class.app-loader--inline]="inline"
  role="status"
  [attr.aria-label]="label"
>
  <span class="app-loader__spinner" aria-hidden="true"></span>
</div>
